import { render, staticRenderFns } from "./ModalReportConfig.vue?vue&type=template&id=ceed4870&"
import script from "./ModalReportConfig.vue?vue&type=script&lang=js&"
export * from "./ModalReportConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports